module.exports = __webpack_public_path__ + "static/media/weather-application-react.87d39024.PNG";